import React from 'react';
import '../App.less';
import { Link } from "react-router-dom";
import { 
    Button,
    Image,
    Typography, 
    Divider, 
    Statistic,
    Tag,
    Row, 
    Col,
    Space,
    PageHeader,
    Avatar,
    Alert
} from 'antd';

import { AntDesignOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;



function sc8r() {
  return (
    <div>
        <Row className="m48-b">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                <div className="">
                    <Row className="m24-b">
                        <Link to="/">
                            <PageHeader
                                onBack={() => null}
                                title="Back to Home"
                            />
                        </Link>
                    </Row>

                    <Row className="m16-b">
                        <Title>Sc8r</Title>
                    </Row>

                    <Row className="m24-b m24-t">
                        <Text>
                            Paired network devices designed to help skaters explore new areas in their city and find new places to practice tricks and moves based on fellow skaters’ recommendations. It uses radio communication and GPS positioning to identify hot spots and haptic vibration to alert the skater when they are nearby.
                        </Text>  
                    </Row>

                    <Row justify="space-between">
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical">
                                <Text className="bitTitle">Advisors</Text>
                                <Text className="bitDesc">
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/vanessajcarpenter/" target="_blank" rel="noopener noreferrer">Vanessa Julia Carpenter</a>,
                                    <a className="nameLinkColor" href=" http://blog.dzl.dk/" target="_blank" rel="noopener noreferrer"> Nikolaj “Dzl” Møbius</a>,
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/olivia-prior-577325153/" target="_blank" rel="noopener noreferrer"> Olivia Prior</a>, 
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/omid-ettehadi/" target="_blank" rel="noopener noreferrer"> Omid Ettehadi</a>
                                </Text>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical">
                                <Text className="bitTitle">Team</Text>
                                <Text className="bitDesc">
                                    <a className="nameLinkColor" href="https://dianapang.net/" target="_blank" rel="noopener noreferrer">Diana Pang</a>,
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/christoff-trexler-11bb31107/" target="_blank" rel="noopener noreferrer"> Christoff Trexler</a>
                                </Text>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical" className="m24-t">
                                <Text className="bitTitle">Sustainable development goals</Text>
                                <Space>
                                    <Image className="sdgImage" src={`../pubAssets/sdg-3.png`}/>
                                    <Image className="sdgImage" src={`../pubAssets/sdg-9.png`}/>
                                    <Image className="sdgImage" src={`../pubAssets/sdg-11.png`}/>
                                </Space>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical" className="m24-t">
                                <Text className="bitTitle">Tags</Text>
                                <Space size={1}>
                                    <Tag>LoRaWAN</Tag>
                                    <Tag>GPS</Tag>
                                </Space>
                                <Space size={1}>
                                    <Tag>CIID</Tag>
                                </Space>
                            </Space>
                        </Col>
                    </Row>

                    

                    
                </div>
            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>

        
        
        <Row className="m80-b">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                <Row>
                    <Image src={require("../assets/projects/sc8r/sc8r_1.png")}/>
                </Row>
                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Space size={4} direction="vertical" className="m80-t">
                            <Text className="projectTitle">challenge</Text>
                            <Text>
                                To create a low-fidelity prototype that explores purpose within the larger scale of the city using LoRa with a focus on range.
                                <br/><br/>
                                Tasked to explore people-to-self connection within the larger scale of the city using LoRa with a focus on range. The team saw skateboarding as an interesting opportunity – while it is an independent sport, skateboarders form a close-knitted community. Street skateboarding has also become popular during the corona virus pandemic with closed skate parks and less traffic on roads. This rise in interest has led people to look for good in which areas to practice.
                            </Text>
                        </Space>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Space size={4} direction="vertical" className="m80-t">
                            <Text className="projectTitle">outcome</Text>
                            <Text>
                                Exploring how we might foster the skateboarding community in San Jose by guiding skaters to areas generated by crowd sourced engagement, we focused on the people-to-self purpose through:
                                <br/><br/>
                                <ul>
                                    <li><strong>Self exploration:</strong> exploring new skills and tricks</li>
                                    <li><strong>Self development:</strong> adapting, practicing, and improving tricks in new areas</li>
                                    <li><strong>Self expression:</strong> interacting with space through different tricks and moves</li>
                                    <li><strong>Self reflection & taking action:</strong> evaluating on one’s skills and decide what’s the best location for practice</li>
                                </ul>
                            </Text>
                        </Space>
                    </Col>
                </Row>
            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>

        
        <Row className="whiteBG p80-t">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                <Title className="whiteBGTitle">Context & Insights</Title>
                <Row className="m24-t" justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                        <Text className="whiteBGTitle">
                            Skateboarding started in San José, Costa Rica as an urban subculture in the late 80s. With strong influences from the surfing culture, skateboarding is becoming more popular which led to a rise of skate parks. There are currently over 100 skate parks in the country.
                            <br/><br/>
                            Historically seen as an activity associated with drugs and vandalism, skateboarding is starting to gain official recognition in Costa Rica in which IOCDER (Costa Rican Institute of Sports and Recreation) granted the sport representation in March 2018.
                        </Text>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Text className="whiteBGTitle">
                            Street skateboarding has become popular during the corona virus pandemic with closed skate parks and less traffic on roads. This rise in interest has led people to look for good in which areas to practice.
                            <br/><br/>
                            While skateboarding is an independent sport, skateboarders form a close-knitted community. Skateboarding often becomes something that is bigger than the sport itself.
                        </Text>
                    </Col>
                </Row>
                <Row className="m80-t" justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={7} xl={7}>
                        <Image src={require("../assets/projects/sc8r/sc8r_2.png")} className="m48-t"/>
                        <div className="m16-t"><Text className="whiteBGTitle"><strong>Identity</strong></Text></div>
                        <div><Text className="whiteBGTitle">Skills derived from skateboarding have positive externalities</Text></div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={7} xl={7}>
                        <Image src={require("../assets/projects/sc8r/sc8r_3.png")} className="m48-t"/>
                        <div className="m16-t"><Text className="whiteBGTitle"><strong>Growth</strong></Text></div>
                        <div><Text className="whiteBGTitle">Cityscape with roughly paved streets provide interesting terrain for skateboarders to crave for challenges</Text></div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                        <Image src={require("../assets/projects/sc8r/sc8r_4.png")} className="m48-t"/>
                        <div className="m16-t"><Text className="whiteBGTitle"><strong>Community</strong></Text></div>
                        <div><Text className="whiteBGTitle">Learning through connections with the community</Text></div>
                    </Col>
                    <Text className="m80-t m80-b HMW" >
                        How might we foster the skateboarding community in San Jose by guiding skaters to areas generated by crowd sourced engagement?
                    </Text>
                </Row>
            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>

        <Row className="m80-t m80-b">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                <Row>
                    <Title>Prototype</Title>
                </Row>
                <Row className="m16-t">
                    <Text>
                        Thinking about what skateboarders has with them and how could be augment those wearables through bodystorming and rapid prototyping.
                    </Text>
                </Row>
                <Row className="m24-t m80-b">
                    <Space size={16} align="start" className="m24-b">
                        <div>
                            <Image src={require("../assets/projects/sc8r/sc8r_7.png")}/>
                            <div  className="m16-t">
                                <Text>
                                    How would a nudge on the knee feel vs the one on the elbow
                                </Text>
                            </div>
                        </div>
                    </Space>
                </Row>
                
                <Row className="m24-b" justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                        <Image className="m24-t"  src={require("../assets/projects/sc8r/sc8r_8.png")}/>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    LoRa connected with GPS sharing position over LoRaWAN which provides seamless interoperability among smart things without the need of complex local installations
                                </Text>
                            </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Image className="m24-t" src={require("../assets/projects/sc8r/sc8r_6.gif")}/>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    LIVE GPS reading. LoRa is bi-directional, but also supports operation such as multicast, enabling mass distribution messages to reduce the on-air communication time
                                </Text>
                            </div>
                    </Col>
                </Row>

                <Row className="m24-b" justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                        <Image className="m24-t" src={require("../assets/projects/sc8r/sc8r_5.gif")}/>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    After testing for vibration on elbow and knees, a user we tested with suggested that the vibration on the head would be felt more.
                                </Text>
                            </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Image className="m24-t" src={require("../assets/projects/sc8r/sc8r_9.png")}/>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    Which led to using the skateboarding helmet as a housing for LoRa
                                </Text>
                            </div>
                    </Col>
                </Row>

                <Row className="m24-b" justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                        <Image className="m16-t" src={require("../assets/projects/sc8r/sc8r_10.png")}/>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Image className="m16-t" src={require("../assets/projects/sc8r/sc8r_11.png")}/>
                    </Col>
                </Row>
                
                <Row>

                    <Space size={16} align="start" className="m80-t m24-b">
                        <Title>Working and Technology</Title>
                    </Space>

                </Row>

                <Row className="m24-b" justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                        <Image className="m24-t" src={require("../assets/projects/sc8r/sc8r_14.png")}/>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    A skateboarder starts from their home, their location being marked as painting on concrete. If they spend more than 2 minutes in a 10m radius, then the location is shared over LoRaWAN
                                </Text>
                            </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Image className="m24-t" src={require("../assets/projects/sc8r/sc8r_15.png")}/>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    This is an indicator that the particular location is a good place for them to practice. This GPS location is stored over the network to be accesed by other devices.
                                </Text>
                            </div>
                    </Col>
                </Row>

                <Row className="m24-b" justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                        <Image className="m24-t" src={require("../assets/projects/sc8r/sc8r_16.png")}/>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    Another skateboarder when passing through the marked location will get notified through the vibrations on their helmet.
                                </Text>
                            </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Image className="m24-t" src={require("../assets/projects/sc8r/sc8r_18.png")}/>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    More people skateboard in a place, makes it easier for the community to move forward
                                </Text>
                            </div>
                    </Col>
                </Row>

                <Row className="m24-b" justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                        <Image className="m24-t" src={require("../assets/projects/sc8r/sc8r_12.png")}/>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    Skateboarder transmitting skate locations when spending more than 2 minutes in an area
                                </Text>
                            </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Image className="m24-t" src={require("../assets/projects/sc8r/sc8r_13.png")}/>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    Other skateboarders accessing skate locations as they pass by
                                </Text>
                            </div>
                    </Col>
                </Row>

                <Row>
                    <Text className="projectTitle">Future considerations</Text>
                </Row>

                <Row justify="space-between m16-t">
                    
                        <Space size={4} direction="vertical">
                            <Text>
                                <ul>
                                    <li>Conduct user testing with skateboarders</li>
                                    <li>Over time how can we start to distinguish advanced skater from beginner</li>
                                    <li>Maybe try to have device limit number of people in area - but that might come off as authoritarian</li>
                                    <li>How can different vibration patterns for different spots enable an extra 6th sense</li>
                                    <li>Usage of EEG sensors in helmet to monitor brain activity for more accurate assessment of skating locations</li>
                                </ul>
                            </Text>
                        </Space>
                </Row>

            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>
    </div>
  );
}

export default sc8r;